export default __webpack_public_path__ + "e281e0768771265d6873bff1d851b4da.svg";